import React from "react";
import { Typography, Tooltip } from "@mui/material";

import { BIN_TO_TEXT_COLOR } from "../constants";

const RiskLabel = ({ label, value, bin, tooltip }) => {
  const percentage = `${Math.round(value * 100)}%`;

  const color = BIN_TO_TEXT_COLOR[bin];

  return (
    <Tooltip title={`${tooltip} (${percentage})`}>
      <Typography variant="caption" sx={{ fontSize: 13 }}>
        {label}:
        <Typography
          variant="caption"
          sx={{ fontWeight: 600, fontSize: 13 }}
          color={color}
        >
          {" "}
          {percentage}
        </Typography>
      </Typography>
    </Tooltip>
  );
};
export default RiskLabel;
